class NonCriticalError extends Error {
}

export default NonCriticalError;
